import CRUD from './CRUD';

export default CRUD;
